import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import PropTypes from 'prop-types';

import Ticker from '../../UiComponents/Ticker/Ticker';
import Arrow from '../../../svg/arrow-top-right-black.svg';

const BeautyPhotographers = ({ foodPhotographers, beautyPhotographers, tickers }) => {
  // Определяем желаемый порядок фотографов
  const desiredOrder = [
    'Claudia Biondini',
    'Cigo',
    'Agnese Cornelio',
    'Greta',
    'Greta Larosa',
    'Luca Paolassini',
    'Elena Senti',
    'Viola Cajo de Cristoforis',
    'Sofia Dalcò',
    'Tiziano Barbieri',
    'Franco Pagetti',
    'Michele Gastl'
  ];
  
  // Объединяем фотографов из обоих источников
  const allPhotographers = [
    ...(foodPhotographers || []),
    ...(beautyPhotographers || [])
  ];
  
  // Сортируем фотографов согласно желаемому порядку
  const sortedPhotographers = [...allPhotographers].sort((a, b) => {
    const indexA = desiredOrder.indexOf(a.title);
    const indexB = desiredOrder.indexOf(b.title);
    
    // Если оба элемента есть в списке желаемого порядка
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    
    // Если только один элемент есть в списке желаемого порядка
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    
    // Если ни один элемент не найден в списке желаемого порядка
    return 0;
  });
  
  return (
    <div className="photographers-portfolio" id="second-section" data-scroll-section>
      <Ticker tickers={tickers} />
      <div className="content-wrapper">
        <div className="photographers-portfolio__items">
          {sortedPhotographers.map((item, index) => {
            return (
              <section className="photographers-portfolio__item" key={index}>
                <div className="portfolio__item-photos">
                  {item.cover.map((photo, index) => {
                    const image = getImage(photo.cover_image.localFile)
                    return (
                      <div
                        className="portfolio__item-photo__wrapper"
                        key={index}
                      >
                        <div
                          className="portfolio__item-photo__wrapper-overflow"
                          data-scroll=""
                          data-scroll-speed={
                            index === 0 ? '-0.7' : index === 1 ? '0' : '0.7'
                          }
                        >
                          <GatsbyImage
                            className="portfolio__item-photo"
                            image={image}
                            alt={item.title}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="portfolio-item__info">
                  <div className="portfolio-item__info-name">
                    <span className="portfolio-item__info-marker">
                      Photographer:
                    </span>
                    <h2 className="portfolio-item__info-title">{item.title}</h2>
                  </div>
                  <Link to={item.link} className="portfolio-item__link">
                    <span className="portfolio-item__link-title">
                      View more
                    </span>
                    <span className="portfolio-item__link-icon">
                      <Arrow />
                    </span>
                  </Link>
                </div>
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
};

BeautyPhotographers.propTypes = {
  foodPhotographers: PropTypes.array,
  beautyPhotographers: PropTypes.array,
  tickers: PropTypes.array,
};

export default BeautyPhotographers;
